export const categories = [
  {
    id: 'shoes',
    name: 'Shoes',
    nameIt: 'Scarpe',
    description: 'Sneakers & Footwear',
    descriptionIt: 'Sneakers e Calzature',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    imageSeq: 'cat-shoes-01',
  },
  {
    id: 'hoodies',
    name: 'Hoodies/Sweaters',
    nameIt: 'Felpe e Maglioni',
    description: 'Hoodies & Sweaters Collection',
    descriptionIt: 'Collezione Felpe e Maglioni',
    url: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
    imageSeq: 'cat-hoodies-02',
  },
  {
    id: 'tshirts',
    name: 'T-Shirts',
    nameIt: 'T-Shirt',
    description: 'T-Shirts & Tops',
    descriptionIt: 'T-Shirt e Top',
    url: 'https://kaspreadsheet.com/search-913/name/Shoes.html',
    imageSeq: 'cat-tshirts-03',
  },
  {
    id: 'jackets',
    name: 'Jackets',
    nameIt: 'Giacche',
    description: 'Jackets & Outerwear',
    descriptionIt: 'Giacche e Capospalla',
    url: 'https://kaspreadsheet.com/search-914/name/Shoes.html',
    imageSeq: 'cat-jackets-04',
  },
  {
    id: 'pants',
    name: 'Pants/Shorts',
    nameIt: 'Pantaloni e Shorts',
    description: 'Pants & Shorts',
    descriptionIt: 'Pantaloni e Pantaloncini',
    url: 'https://kaspreadsheet.com/search-915/name/Shoes.html',
    imageSeq: 'cat-pants-05',
  },
  {
    id: 'headwear',
    name: 'Headwear',
    nameIt: 'Copricapo',
    description: 'Hats & Caps',
    descriptionIt: 'Cappelli e Berretti',
    url: 'https://kaspreadsheet.com/search-916/name/Shoes.html',
    imageSeq: 'cat-headwear-06',
  },
  {
    id: 'sets',
    name: 'Sets',
    nameIt: 'Set Completi',
    description: 'Matching Sets',
    descriptionIt: 'Set Abbinati',
    url: 'https://kaspreadsheet.com/search-917/name/Shoes.html',
    imageSeq: 'cat-sets-07',
  },
  {
    id: 'underwear',
    name: 'Underwear/Underpants',
    nameIt: 'Intimo',
    description: 'Underwear Collection',
    descriptionIt: 'Collezione Intimo',
    url: 'https://kaspreadsheet.com/search-918/name/Shoes.html',
    imageSeq: 'cat-underwear-08',
  },
  {
    id: 'jersey',
    name: 'Jersey',
    nameIt: 'Maglie Sportive',
    description: 'Sports Jerseys',
    descriptionIt: 'Maglie da Calcio e Sport',
    url: 'https://kaspreadsheet.com/search-919/name/Shoes.html',
    imageSeq: 'cat-jersey-09',
  },
  {
    id: 'accessories',
    name: 'Accessories',
    nameIt: 'Accessori',
    description: 'Fashion Accessories',
    descriptionIt: 'Accessori Moda',
    url: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
    imageSeq: 'cat-accessories-10',
  },
  {
    id: 'bags',
    name: 'Bags',
    nameIt: 'Borse',
    description: 'Bags & Backpacks',
    descriptionIt: 'Borse e Zaini',
    url: 'https://kaspreadsheet.com/search-921/name/Shoes.html',
    imageSeq: 'cat-bags-11',
  },
  {
    id: 'belts',
    name: 'Belts',
    nameIt: 'Cinture',
    description: 'Belts Collection',
    descriptionIt: 'Collezione Cinture',
    url: 'https://kaspreadsheet.com/search-922/name/Shoes.html',
    imageSeq: 'cat-belts-12',
  },
  {
    id: 'perfumes',
    name: 'Perfumes',
    nameIt: 'Profumi',
    description: 'Fragrances',
    descriptionIt: 'Fragranze e Profumi',
    url: 'https://kaspreadsheet.com/search-923/name/Shoes.html',
    imageSeq: 'cat-perfumes-13',
  },
  {
    id: 'other',
    name: 'Other Stuff',
    nameIt: 'Altro',
    description: 'More Products',
    descriptionIt: 'Altri Prodotti',
    url: 'https://kaspreadsheet.com/search-924/name/Shoes.html',
    imageSeq: 'cat-other-14',
  },
];